import MDBox from "components/MDBox";
import MDInput from "components/MDInput";
import MDButton from "components/MDButton";
import { FormControl, InputLabel, MenuItem, Select } from "@mui/material";
import { useEffect, useState } from "react";
import { updateUserCall } from "api/api";
import { checkPermission, getIsSuperAdmin } from "../../helpers/checkPermission";
import permissions from "../../config/permissions";
import Modal from "../../components/modal";

export default function UpdateAdminForm({ onClose, reload, user }) {
  const [state, setState] = useState({
    name: "",
    userName: "",
    organizationName: "",
    isActive: false,
  });

  const isSuperAdmin = getIsSuperAdmin();

  const onUpdate = async () => {
    if (!state.name) {
      return global.showAlert("Validation Errors", "Name is required to update a user", "warning");
    }

    const response = await updateUserCall(user.id, {
      name: state.name,
      is_active: state.isActive,
    });
    if (response) {
      reload();
    }
  };

  useEffect(() => {
    if (user) {
      setState({
        name: user.name,
        userName: user.user_name,
        isActive: user.is_active,
        organizationName: user.organization?.name,
      });
    }
  }, [user]);

  return (
    user && (
      <Modal
        title={"Update user"}
        open={user}
        actions={
          <MDBox display="flex" gap={1} justifyContent="right">
            <MDButton onClick={onUpdate} variant="gradient" color="info">
              submit
            </MDButton>
            <MDButton onClick={onClose} variant="gradient" color="error">
              cancel
            </MDButton>
          </MDBox>
        }
      >
        <MDBox component="form" role="form">
          {isSuperAdmin && (
            <MDBox mb={2}>
              <MDInput
                type="string"
                label="Organization"
                fullWidth
                value={state.organizationName}
                disabled
              />
            </MDBox>
          )}

          <MDBox mb={2}>
            <MDInput
              type="string"
              label="Name"
              fullWidth
              value={state.name}
              onChange={(event) => {
                setState({ ...state, name: event.target.value });
              }}
            />
          </MDBox>
          <MDBox mb={2}>
            <MDInput type="string" label="User Name" fullWidth value={state.userName} disabled />
          </MDBox>
          <MDBox mb={2}>
            <FormControl fullWidth>
              <InputLabel>Status</InputLabel>
              <Select
                value={state.isActive}
                label="Status"
                style={{
                  paddingBottom: "0.75rem",
                  paddingTop: "0.75rem",
                }}
                onChange={(event) => {
                  setState({ ...state, isActive: event.target.value });
                }}
                disabled={!checkPermission(permissions().rolePermission().create().update().list())}
              >
                <MenuItem value={true}>Active</MenuItem>
                <MenuItem value={false}>Inactive</MenuItem>
              </Select>
            </FormControl>
          </MDBox>
        </MDBox>
      </Modal>
    )
  );
}
